import { render, staticRenderFns } from "./SideComponent.vue?vue&type=template&id=4690028e&"
import script from "./SideComponent.vue?vue&type=script&lang=js&"
export * from "./SideComponent.vue?vue&type=script&lang=js&"
import style0 from "./SideComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports